<template lang="html">
  <component :is="tag" class="text__accent" :class="{ bold, adaptive: adaptive }">
    <!-- @slot Безымянный слот. Используется для вставки текста-->
    <slot/>
  </component>
</template>

<script>
export default {
  name: 'bimTextAccent',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.text__accent {
  font-size: 24px;
  font-weight: normal;
  line-height: 1.29;
  letter-spacing: normal;
}

.text__accent.bold {
  font-weight: bold;
}

@media all and (max-width: $phone-width) {
  .text__accent.adaptive {
    font-size: 20px;
    line-height: 1.35;
  }
}
</style>
